/* eslint-disable react-hooks/exhaustive-deps */
import { Tooltip, styled, Button, Typography } from "@material-ui/core";
import { Timestamp } from "firebase/firestore";
import React, { useState, useEffect, useContext } from "react";
import dayjs from "dayjs";
import moment from "moment-timezone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { acuitygetAppointments } from "../../../services/apiservices/acuity";
import {
  getTimesheetList,
  timeSheetUpdateTime,
  timeSheetDeleteTime,
} from "../../../services/apiservices/timesheets";
import {
  getCompanyClients,
} from "../../../services/apiservices/client";
import TimeZoneData from "../../../assets/timezones.json";
import styles from "../dashboard.module.scss";
import {
  Box,
  Collapse,
  IconButton,
  Stack,
  TableCell,
  TableRow,
} from "@mui/material";
import {
  getCompanyEmployees,
} from "../../../services/apiservices/employee";
import AuthContext from "../../../hooks/authContext";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Link } from "react-router-dom";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "../../../components/ui/hover";
import { ClockInOut, ShiftStatus } from "./ClockInOutComponent";
import { getAppoinmentByDates, subscribeToAppointmentsByDates } from "../../../services/apiservices/appoinments";

function useClientSummary(isLimit = false) {
  const auth = useContext(AuthContext);
  const [sort, setSort] = useState("DESC");
  const [filterDate, setFilterDate] = useState(moment().format("YYYY-MM-DD"));
  const [clientsList, setClientList] = useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [show, setShow] = useState(false);
  const [employee, setEmployees] = useState();
  const [clients, setClients] = useState();
  const [appointments, setAppointments] = useState([]);
  const [checkInDateTime, setCheckInDateTime] = useState(null);
  const [checkOutDateTime, setCheckOutDateTime] = useState(null);
  const [durationString, setDurationString] = useState("—");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const isClient = auth?.userProfile?.role === "Client";
  const localClientID = localStorage.getItem('clientId');
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const clientId = localClientID ? localClientID : auth?.userProfile?.client;
  const setIsModalOpen = auth.setIsModalOpen;
  const setSelectedAppointment = auth.setSelectedAppointment;

  const getTimeZoneData = (timeZoneStr) =>
    TimeZoneData.find((item) => {
      if (item?.utc) {
        return !!item?.utc.find((subItem) => subItem === timeZoneStr);
      }
      return false;
    });

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: "#ffffff",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 500,
      width: "100%",
      padding: 0,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #bbbbbb",
    },
  }));

  const onChangeInput = (e) => {
    setSort(e.target.value);
  };
  const getClientsSummaryData = async (forceRefresh = false) => {
    setIsLoading(true);
  //  if (forceRefresh) {
  //       acuitygetAppointments(
  //         {
  //           minDate: moment(filterDate).format(moment.HTML5_FMT.DATE),
  //           maxDate: moment(filterDate).format(moment.HTML5_FMT.DATE),
  //           max: 100,
  //         },
  //         async (result) => {
  //           // insertAppts(result.data.data);
  //           return;
  //         }
  //       );
  //     }

  
      // const appointmentDaetails = timesheetData ? timesheetData : appointments;
      // const todaysData = appointmentDaetails?.filter(appt => {
      //   const tz = appt?.apoointmentDetails?.calendarTimezone || "America/New_York";

      //   const apptDate = moment.tz(appt.appointmentDateTime, tz).format("YYYY-MM-DD");

      //   return apptDate === filterDate;
      // });
    try {
      const [timesheetData, appointmentRes, clientsRes, employeesRes] = await Promise.all([
        new Promise((resolve, reject) =>
          getTimesheetList(
            { appointmentDate: moment(filterDate).format("MMMM D, YYYY"), companyId },
            resolve,
            reject
          )
        ).catch(() => []),
        getAppoinmentByDates(moment(filterDate).format("YYYY-MM-DDTHH:mm:ss"), null, companyId),
        new Promise((resolve, reject) => getCompanyClients(companyId, resolve, reject))
          .then(res => res?.data || [])
          .catch(() => []),
        new Promise((resolve, reject) => getCompanyEmployees(companyId, resolve, reject))
          .then(res => res?.data || [])
          .catch(() => []),
      ]);

      const clientsMap = new Map(clientsRes?.map(c => [c?.id, c]));
      const excludedEmpIds = new Set(
        employeesRes.filter(emp => !emp?.status || emp?.deleted)?.map(emp => emp?.userId)
      );

      setAppointments(appointmentRes?.appointments || []);
      setEmployees(employeesRes);
      setClients(clientsRes);

      const finalResult = timesheetData?.filter(appt => !excludedEmpIds?.has(appt?.userId) && (!isClient || appt?.clientId === clientId))
        ?.map(appt => {
          const client = clientsMap?.get(appt.clientId);
          const duration = appt?.apoointmentDetails?.duration || 0;

          return {
            ...appt,
            clientDetails: client,
            name: client?.clientName,
            shift: getShiftName(appt?.apoointmentDetails?.forms),
            datestart: moment(appt?.appointmentDateTime)?.format("MMMM DD YYYY, h:mm a"),
            dateend: moment(appt?.appointmentDateTime)?.add(appt?.apoointmentDetails.duration, "minutes")?.format("MMMM DD YYYY, h:mm a"),
            datetime: appt?.appointmentDateTime,
            duration,
            calendarTimezone: appt?.apoointmentDetails?.calendarTimezone,
            calendar: appt?.apoointmentDetails?.calendar,
          };
        })
        ?.sort((a, b) =>
          sort === "ASC"
            ? moment(a?.datetime) - moment(b?.datetime)
            : moment(b?.datetime) - moment(a?.datetime)
        );

      setClientList(finalResult);
      setIsLoading(false);

    } catch (error) {
      console.error("Error in getClientsSummaryData:", error);
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   const startDate = moment(filterDate, "YYYY-MM-DD").startOf("day").format("YYYY-MM-DDTHH:mm:ss") || moment().tz("America/New_York").startOf("day").format("YYYY-MM-DDTHH:mm:ss");
  //   const unsubscribe = subscribeToAppointmentsByDates(
  //     startDate,
  //     null,
  //     companyId,
  //       (data) => {
  //       setAppointments(data);
  //       getClientsSummaryData(data);
  //     },
  //     (err) => console.error("Snapshot error:", err)
  //   );

  //     return () => unsubscribe && unsubscribe();
  // }, [filterDate, companyId, sort]);

  const getTaskListByComma = (timeSheetData, isOpen = 0) => {
    if (!timeSheetData) return [];

    const seenTitles = new Set();
    let retTask = [];

    for (const key in timeSheetData?.tasks) {
      const shift = timeSheetData?.tasks[key];
      if (shift?.tasksList) {
        const tasks = shift?.tasksList?.filter((task) =>
          (isOpen === 1 && task?.shname === "Opentasks") ||
          (isOpen === 0 && task?.shname !== "Opentasks") ||
          (isOpen === 2 && task?.completed)
        );

        tasks?.forEach((task) => {
          if (task?.title && !seenTitles.has(task?.title)) {
            seenTitles.add(task?.title);
            retTask.push(task?.title);
          }
        });
      }
    }

    return retTask;
  };

  const getStatusTag = (cellData) => {
    let dotColor = "#f59e0b";
    let textColor = "#f59e0b";
    let backgroundColor = "rgba(235, 221, 65, 0.15)";
    let label = "";

    const calendarTimezone = cellData?.calendarTimezone || "America/New_York";
    const appointmentDateTime = cellData?.datetime || cellData?.appointmentDateTime;

    const appointment = dayjs(appointmentDateTime).tz(calendarTimezone);
    const now = dayjs().tz(calendarTimezone);

    const minutesSinceAppointment = now.diff(appointment, "minute");

    if (cellData) {
      const timeSheetData = cellData;
      const secsToGet = timeSheetData?.checkInDateTime || timeSheetData?.createdAt;

      let seconds;
      if (secsToGet?.toJSON) {
        seconds = secsToGet.toJSON()["seconds"];
      } else if (secsToGet) {
        seconds = secsToGet["seconds"];
      }

      const checkIn = dayjs.unix(seconds).tz(calendarTimezone);
      const minutesLate = checkIn.diff(appointment, "minute");
      const now = moment();
      const isFuture = moment(appointmentDateTime).isAfter(now);
      const hasCheckIn = !!timeSheetData?.checkInDateTime;

      if (!hasCheckIn) {
        if (isFuture) {
          dotColor = "#F9BC0A";
          textColor = "#F9BC0A";
          backgroundColor = "rgba(235, 221, 65, 0.15)";
          label = "Scheduled";
        } else {
          dotColor = "#cc1716";
          textColor = "#cc1716";
          backgroundColor = "rgba(204, 23, 22, 0.15)";
          label = "Not Started";
        }
      } else if (hasCheckIn && minutesLate <= 5) {
        dotColor = "#078037";
        textColor = "#078037";
        backgroundColor = "rgba(7, 128, 55, 0.15)";
        label = "Started";
      } else if (hasCheckIn && minutesLate > 5) {
        dotColor = "#ff7e00";
        textColor = "#ff7e00";
        backgroundColor = "rgba(255, 126, 0, 0.15)";
        label = "Late Start";
      }
    }

    // const dt2 = moment(cellData?.["datetime"]);
    //     const dt3 = moment();
    //     const minutes1 = moment.duration(dt3.diff(dt2)).asMinutes();

    //     if (cellData) {
    //       const timeSheetData = cellData;
    //       const secsToGet =
    //         timeSheetData?.checkInDateTime || timeSheetData?.createdAt;
    //       let seconds;

    //       if (secsToGet?.toJSON) {
    //         seconds = secsToGet.toJSON()["seconds"];
    //       } else if (secsToGet) {
    //         seconds = secsToGet["seconds"];
    //       }

    //       const dt1 = moment(seconds);
    //       const minutes = moment.duration(dt2.diff(dt1)).asMinutes();

    //       if (timeSheetData["isWorking"] || timeSheetData["completed"]) {
    //         dotColor = "#078037"; // green
    //         textColor = "#078037";
    //         backgroundColor = "rgba(7, 128, 55, 0.15)";
    //       } else if (timeSheetData?.checkInDateTime && minutes > 15) {
    //         dotColor = "#cc1716"; // red
    //         textColor = "#cc1716";
    //         backgroundColor = "rgba(204, 23, 22, 0.15)";
    //       } else if (timeSheetData?.checkInDateTime && minutes > 10) {
    //         dotColor = "#ff7e00"; // orange
    //         textColor = "#ff7e00";
    //         backgroundColor = "rgba(255, 126, 0, 0.15)";
    //       } else if (minutes1 > 15) {
    //         dotColor = "#cc1716";
    //         textColor = "#cc1716";
    //         backgroundColor = "rgba(204, 23, 22, 0.15)";
    //       }
    //     } else if (minutes1 > 15) {
    //       dotColor = "#cc1716";
    //       textColor = "#cc1716";
    //       backgroundColor = "rgba(204, 23, 22, 0.15)";
    //     }

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          backgroundColor,
          color: textColor,
          padding: "2px 8px",
          borderRadius: "9999px",
          fontSize: "0.875rem",
          fontWeight: 500,
          whiteSpace: "nowrap",
        }}
      >
        <span
          style={{
            width: 8,
            height: 8,
            backgroundColor: dotColor,
            borderRadius: "50%",
            marginRight: 6,
          }}
        ></span>
        {label}
      </span>
    );
  };

  const getTaskCount = (taskListArr, isAssigned) => {
    if (!taskListArr || !taskListArr?.tasks) return <span className="text-[#020817] dark:text-white">0</span>;

    let retTask = 0;
    const seenTaskIds = new Set();

    for (const key in taskListArr?.tasks) {
      const shift = taskListArr?.tasks[key];
      if (shift?.tasksList) {
        shift?.tasksList?.forEach((task) => {
          const tId = task?.taskId || task?.id;
          if (!tId || seenTaskIds.has(tId)) return;
          seenTaskIds.add(tId);

          if (isAssigned) {
            retTask += 1;
          } else if (!isAssigned && task?.completed) {
            retTask += 1;
          }
        });
      }
    }

    return <span className="text-[#020817] dark:text-white">{retTask}</span>;
  };

  const getShiftName = (formValues) => {
    if (formValues && formValues.length > 0) {
      const frmData = formValues[0];
      const shiftVal = frmData?.values.find(
        (itm) =>
          itm.name.trim() === "ShiftName" || itm.name.trim() === "Shift Name"
      );
      if (shiftVal) {
        return shiftVal.value || "---";
      }
    }
    return "---";
  };

  const toggleShow = (id) => {
    setShow((prevState) => {
      const updatedShow = { ...prevState };
      if (updatedShow[id]) {
        updatedShow[id] = false;
      } else {
        Object.keys(updatedShow).forEach((key) => {
          updatedShow[key] = false;
        });
        updatedShow[id] = true;
      }
      return updatedShow;
    });
  };

  const combineTime = (time, timezone) => {
    let timezoneOffset = moment().tz(timezone).format("Z");
    const onlyTime = moment(time, "YYYY-MM-DD hh:mm A").format("HH:mm:ss");
    const onlyDate = moment(time, "YYYY-MM-DD hh:mm A").format("YYYY-MM-DD");
    const mytime = `${onlyDate}T${onlyTime}${timezoneOffset}`;
    return new Date(mytime);
  };

  const handleUpdateCheckIn = async (time, cellData) => {
    const timezone = cellData?.calendarTimezone
      ? cellData?.calendarTimezone
      : "America/New_York";
    const combinedTime = combineTime(
      `${moment(cellData?.datestart).format("YYYY-MM-DD")} ${time}`,
      timezone
    );
    setCheckInDateTime(combinedTime);

    const formData = {
      checkInDateTime: Timestamp.fromDate(combinedTime),
      isWorking: true,
    };

    await timeSheetUpdateTime(cellData?.id, formData);
  };

  const handleUpdateCheckOut = async (time, cellData) => {
    const timezone = cellData?.calendarTimezone
      ? cellData?.calendarTimezone
      : "America/New_York";
    const combinedTime = combineTime(
      `${moment(cellData?.datestart).format("YYYY-MM-DD")} ${time}`,
      timezone
    );
    setCheckOutDateTime(combinedTime);
    const formData = {
      checkOutDateTime: Timestamp.fromDate(combinedTime),
      completed: true,
      isWorking: false,
    };
    await timeSheetUpdateTime(cellData?.id, formData);
  };

  const handelDeleteTime = async (cellData) => {
    setShow(false);
    if (checkInDateTime || checkInDateTime) {
      await timeSheetDeleteTime(
        cellData?.apoointmentDetails?.id,
        cellData?.appointmentDate,
        ["checkInDateTime", "checkOutDateTime"]
      );
      await getClientsSummaryData();
    }
  };

  const saveData = async (cellData) => {
    setShow(false);
    if (checkInDateTime || checkInDateTime) {
      if (checkInDateTime) {
        await handleUpdateCheckIn(checkInDateTime, cellData);
      }
      if (checkOutDateTime) {
        await handleUpdateCheckOut(checkOutDateTime, cellData);
      }
      await getClientsSummaryData();
    }
  };

  const renderRow = () => {
    return clientsList?.slice(0, itemsPerPage)?.map((appointment) => {
      const timezones = appointment?.calendarTimezone
        ? appointment?.calendarTimezone
        : "America/New_York";
      const timezone = getTimeZoneData(timezones);

      const formattedStartDate = moment(appointment["appointmentDateTime"])
        .parseZone(appointment.calendarTimezone || moment.tz.guess())
        .format("MMM DD YYYY");
      const formattedStartTime = moment(appointment["appointmentDateTime"])
        .parseZone(appointment.calendarTimezone || moment.tz.guess())
        .format("h:mm a");

      const formattedEndDate = moment(appointment["appointmentDateTime"])
        .add(appointment["duration"], "minutes")
        .parseZone(appointment.calendarTimezone || moment.tz.guess())
        .format("MMM DD YYYY");
      const formattedEndTime = moment(appointment["appointmentDateTime"])
        .add(appointment["duration"], "minutes")
        .parseZone(appointment.calendarTimezone || moment.tz.guess())
        .format("h:mm a");

      const getRegularTask = getTaskListByComma(appointment);
      const getOpenTask = getTaskListByComma(appointment, 1);
      const getCompletedTask = getTaskListByComma(appointment, 2);

      return (
        <React.Fragment key={appointment.id}>
          <TableRow
            className={`bg-white dark:bg-[#1A1F2C] text-[#020817] dark:text-white hover:bg-[#f8fafc] dark:hover:bg-[#2c3440] border-white dark:border-white`}
          >
            <TableCell>
              <div className="d-flex flex-direction-column">
                <Link
                  to={`/peoples/createClient/${appointment?.clientId}`}
                  className="cursor-pointer no-underline font-medium text-[#020817] dark:text-white"
                >
                  {appointment["name"]}
                </Link>
                <Box>
                  <Link
                    to={`/peoples/createEmp/${appointment?.userId}`}
                    className="text-gray-600 text-[12px] no-underline italic"
                  >
                    {appointment?.calendar}
                  </Link>
                </Box>
              </div>
            </TableCell>

            <TableCell>{getStatusTag(appointment)}</TableCell>

            <TableCell>
              <ShiftStatus
                appointment={appointment}
                refreshData={getClientsSummaryData}
                isEdit={show[appointment.id]}
                setShow={setShow}
              />
            </TableCell>

            <TableCell>
              <Typography variant="caption" className={`${styles.customHeader} text-[#020817] dark:text-white`}>
                {formattedStartDate}
              </Typography>
              <Typography variant="body2" className="text-[#020817] dark:text-white">
                {formattedStartTime} {timezone?.abbr}
              </Typography>
            </TableCell>

            <TableCell>
              <Typography variant="caption" className={`${styles.customHeader} text-[#020817] dark:text-white`}>
                {formattedEndDate}
              </Typography>
              <Typography variant="body2" className="text-[#020817] dark:text-white">
                {formattedEndTime} {timezone?.abbr}
              </Typography>
            </TableCell>

            <TableCell align="right">
              <IconButton
                size="small"
                onClick={() => toggleShow(appointment.id)}
              >
                {show[appointment.id] ? (
                  <ExpandLess className="text-black dark:text-white" />
                ) : (
                  <ExpandMore className="text-black dark:text-white" />
                )}
              </IconButton>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={6} sx={{ p: 0, border: 0 }}>
              <Collapse in={show[appointment.id]} timeout="auto" unmountOnExit>
                <Box className="px-6 py-4 bg-[#f8fafc] dark:bg-[#1A1F2C]">
                  <Box
                    className="grid gap-2 mb-2"
                    sx={{
                      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
                    }}
                  >
                    <Box>
                      <Typography
                        variant="body"
                        className={`${styles.texts} text-[#020817] dark:text-white`}
                      >
                        Details
                      </Typography>
                      <Box mt={1}>
                        <span
                          onClick={() => {
                            setSelectedAppointment(appointment);
                            setIsModalOpen(true);
                          }}
                          className="text-blue-600 text-sm cursor-pointer"
                        >
                          View Details
                        </span> 
                      </Box>
                    </Box>

                    <Box>
                      <Typography
                        variant="body"
                        className={`${styles.texts} text-[#020817] dark:text-white`}
                      >
                        Tasks
                      </Typography>
                      <Stack spacing={0.5} mt={1}>
                        {/* Assigned Tasks */}
                        <Box display="flex" alignItems="center" fontSize={14}>
                          <span
                            className={`${styles.customHeader} text-[#020817] dark:text-white`}
                          >
                            Assigned:
                          </span>
                          <HoverCard>
                            <HoverCardTrigger asChild>
                              <Button className={styles.expandIcons}>
                                {getTaskCount(appointment, true)}
                              </Button>
                            </HoverCardTrigger>
                            <HoverCardContent
                              className="bg-white dark:bg-gray-800 p-20 shadow-lg border border-gray-200 dark:border-gray-700 rounded-md z-50 text-[#020817] dark:text-white"
                              align="start"
                              side="right"
                              sideOffset={5}
                            >
                              <div className="max-w-xs">
                                <h5 className="mb-10 font-semibold text-lg">
                                  Assigned Tasks
                                </h5>
                                <div>
                                  {getRegularTask?.map((item, index) => (
                                    <p
                                      key={`regular-${index}`}
                                      className="flex items-center mb-4"
                                    >
                                      <span className="w-1 h-1 bg-[#020817] dark:bg-white rounded-full mr-6 inline-block"></span>
                                      <span className="ml-8">{item}</span>
                                    </p>
                                  ))}
                                </div>
                              </div>

                              {getOpenTask?.length > 0 && (
                                <div className="max-w-xs mt-15">
                                  <h5 className="font-semibold text-lg mb-8">
                                    Open Tasks
                                  </h5>
                                  <div>
                                    {getOpenTask?.map((item, index) => (
                                      <p
                                        key={`open-${index}`}
                                        className="flex items-center mb-4"
                                      >
                                        <span className="w-1 h-1 bg-[#020817] dark:bg-white rounded-full mr-6 inline-block"></span>
                                        <span className="ml-5">{item}</span>
                                      </p>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </HoverCardContent>
                          </HoverCard>
                        </Box>

                        <Box display="flex" alignItems="center" fontSize={14}>
                          <span
                            className={`${styles.customHeader} text-[#020817] dark:text-white`}
                          >
                            Completed:
                          </span>
                          <HoverCard>
                            <HoverCardTrigger asChild>
                              <Button className={styles.expandIcons}>
                                {getTaskCount(appointment, false)}
                              </Button>
                            </HoverCardTrigger>
                            <HoverCardContent
                              className="bg-white dark:bg-gray-800 p-20 shadow-lg border border-gray-200 dark:border-gray-700 rounded-md z-50 text-[#020817] dark:text-white"
                              align="start"
                              side="right"
                              sideOffset={5}
                            >
                              <div className="max-w-xs">
                                <h5 className="mb-10 font-semibold text-lg">
                                  Completed Tasks
                                </h5>
                                <div>
                                  {getCompletedTask?.map((item, index) => (
                                    <p
                                      key={`completed-${index}`}
                                      className="flex items-center mb-4"
                                    >
                                      <span className="w-1 h-1 bg-[#020817] dark:bg-white rounded-full mr-2 inline-block"></span>
                                      <span className="ml-2">{item}</span>
                                    </p>
                                  ))}
                                </div>
                              </div>
                            </HoverCardContent>
                          </HoverCard>
                        </Box>
                      </Stack>
                    </Box>

                    <Box>
                      <div className="flex items-center">
                        <AccessTimeIcon
                          fontSize="small"
                          className="text-blue-500"
                        />
                        <Typography
                          variant="body2"
                          className={`${styles.texts} ml-5 text-[#020817] dark:text-white`}
                        >
                          Clock Times
                        </Typography>
                      </div>
                      <Stack spacing={0.5} mt={1}>
                        <Box
                          fontSize={14}
                          className="text-[#020817] dark:text-white"
                        >
                          {show[appointment.id] ? (
                            <ClockInOut
                              cellData={appointment}
                              show={show[appointment.id]}
                              checkInDateTime={checkInDateTime}
                              setCheckInDateTime={setCheckInDateTime}
                              checkOutDateTime={checkOutDateTime}
                              setCheckOutDateTime={setCheckOutDateTime}
                              setDurationString={setDurationString}
                              durationString={durationString}
                            />
                          ) : (
                            <div>
                              <div>In: ----</div>
                              <div>Out: ----</div>
                            </div>
                          )}
                        </Box>
                      </Stack>
                    </Box>
                  </Box>

                  <Box className="flex justify-end gap-2 mt-10">
                    <Button
                      className="dark:text-white"
                      variant="outlined"
                      size="small"
                      onClick={() => handelDeleteTime(appointment)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      className="saveButton text-white dark:bg-[#078037] dark:text-white"
                      onClick={() => saveData(appointment)}
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
        </React.Fragment>
      );
    });
  };
  useEffect(() => {
    getClientsSummaryData();
  }, [sort, filterDate]);

  const handleDateChange = (newValue) => {
    setFilterDate(newValue.target.value);
  };

  const changeDate = (days) => {
    const newDate = moment(filterDate).add(days, "days").format("YYYY-MM-DD");
    setFilterDate(newDate);
  };

  return {
    sort,
    setSort,
    filterDate,
    setFilterDate,
    clientsList,
    setClientList,
    isLoading,
    setIsLoading,
    handleDateChange,
    getClientsSummaryData,
    renderRow,
    getShiftName,
    getTaskCount,
    getStatusTag,
    getTaskListByComma,
    onChangeInput,
    HtmlTooltip,
    setShow,
    show,
    getTimeZoneData,
    toggleShow,
    changeDate,
    itemsPerPage,
    setItemsPerPage,
    employee,
    clients,
    appointments,
  };
}

export default useClientSummary;
